export const enum srpFilters {
  Promotion = 'Promotion',
  BodyStyle = 'Body Style',
  FuelType = 'Fuel Type',
  Make = 'Make',
  Model = 'Model',
  Year = 'Model Year'
}
